import { adminRecords } from "./adminRecords";
import React, { useEffect, useState } from "react";
import Auth from "../Auth";
import Subscription from "../models/Subscription";

const BulkEditUsers = (props) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [emailInput, setEmailInput] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [failedUpdates, setFailedUpdates] = useState([]);
  const [wordPackQuota, setWordPackQuota] = useState(0);

  useEffect(() => {
    refreshTable();
  }, []);

  const handleEmailChange = (event) => {
    setEmailInput(event.target.value);
  };

  const handleEmailSubmit = async (event) => {
    event.preventDefault();

    // re-set any success or error messages from prev update
    setFailedUpdates([]);
    setSuccessMessage("");

    const emails = emailInput.split("\n").map((email) => email.trim());

    const updatePromises = emails.map(async (email) => {
      const querySnapshot = await adminRecords.collection("subscriptions").where("email", "==", email).get();

      if (querySnapshot.empty) {
        return Promise.reject(new Error(`No subscription found for email: ${email}`));
      }

      const userId = querySnapshot.docs[0].id;
      const subscription = new Subscription(userId);
      subscription.fetchFromDoc(querySnapshot.docs[0]);
      const amount = parseInt(wordPackQuota);

      if (!subscription.usesLedgers) {
        console.log("updating pack quota", amount);
        await Auth.fetchWithIdToken(`/api/admin/user/${userId}`, { method: "PUT", update: { packQuota: amount } });
      } else {
        console.log("updating ledger", amount);
        await Auth.fetchWithIdToken(`/api/admin/ledger/${userId}/add`, {
          amount,
          expire: false,
        });
      }

      return {
        email,
      };
    });

    const results = await Promise.allSettled(updatePromises);
    console.log("results", results);

    refreshTable();
    let success = [];
    let failed = [];
    let updateErr = false;

    results.forEach((result) => {
      if (result.status === "fulfilled") {
        success.push(result.value.email);
      } else {
        updateErr = true;
        failed.push(result.reason);
      }
    });

    setSuccessMessage(`Successfully updated emails: ${success.join(", ")}`);
    if (updateErr) {
      setFailedUpdates(failed);
    }
  };

  const refreshTable = async () => {
    const emails = emailInput
      .split("\n")
      .map((email) => email.trim())
      .filter((email) => email);

    try {
      let users = await props.userCache.fetchEmails(emails);

      if (users) {
        const subsByEmail = users.map((user) => user.subscription);

        setSubscriptions(subsByEmail);
        setLoading(false);
      }
    } catch (e) {
      setError(e);
      setLoading(false);
    }
  };

  if (loading) {
    return <p>Loading subscriptions...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <>
      <form onSubmit={handleEmailSubmit}>
        <label>
          Paste in emails (one per line):
          <br />
        </label>
        <textarea
          value={emailInput}
          onChange={handleEmailChange}
          style={{ width: "400px", height: "200px" }}
        />
        <br />
        <label>
          Amount to add to pack quota:
          <input
            value={wordPackQuota}
            onChange={(e) => setWordPackQuota(e.target.value)}
            type="number"
            step={1}
          />
        </label>
        <br />
        <button
          onClick={(e) => {
            e.preventDefault();
            refreshTable();
          }}
        >
          Load Users
        </button>
        <button type="submit">Bulk Update Users</button>
      </form>
      <br />
      {failedUpdates.map((err, index) => (
        <p
          style={{ color: "red" }}
          key={index}
        >
          {err.message}
        </p>
      ))}
      <br />
      {successMessage && <p>{successMessage}</p>}
      <br />
      <br />

      <table style={{ borderCollapse: "collapse", border: "1px solid #ccc" }}>
        <thead>
          <tr>
            <th style={{ padding: "10px" }}>Subscription ID</th>
            <th style={{ padding: "10px" }}>Email</th>
            <th style={{ padding: "10px" }}>Pack Quota</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map((subscription) => (
            <tr key={subscription.id}>
              <td style={{ padding: "10px", border: "1px solid #ccc" }}>{subscription.id}</td>
              <td style={{ padding: "10px", border: "1px solid #ccc" }}>{subscription.data.email}</td>

              <td style={{ padding: "10px", border: "1px solid #ccc" }}>{subscription.packQuota}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default BulkEditUsers;
